export default {
  title: 'Configuración de semáforo',
  description:
    'Defina el valor para los respectivos colores y niveles de criticidad. El valor se considera en minutos.',
  critic: 'Crítico',
  warning: 'Atención'
}
